// Wishlist — ports the old WishlistProvider/WishlistButton/WishlistClient.
// Saved product ids live in localStorage; nothing is sent to Shopify.
(() => {
  const KEY = 'mizu_wishlist_v2';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
  };
  const write = (ids) => {
    try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch { /* storage blocked */ }
  };

  // Badge mounts only when count > 0 and pulses once on mount, like the old <Badge>.
  function renderBadge(ids) {
    const badge = document.querySelector('[data-mizu-wish-badge]');
    if (!badge) return;
    badge.textContent = ids.length;
    badge.hidden = ids.length === 0;
  }

  function renderButton(btn, ids) {
    const on = ids.includes(btn.dataset.mizuWishToggle);
    const heart = btn.querySelector('span');
    btn.setAttribute('aria-pressed', String(on));
    btn.setAttribute('aria-label', on ? btn.dataset.labelRemove : btn.dataset.labelAdd);
    heart.textContent = on ? '♥' : '♡';
    heart.className = on ? 'text-water' : 'text-stone';
  }

  function renderPage(ids) {
    const page = document.querySelector('[data-mizu-wishlist-page]');
    if (!page) return;
    const grid = page.querySelector('[data-wl-grid]');
    page.querySelector('[data-wl-loading]').hidden = true;
    const items = ids.map((id) => grid.querySelector(`[data-wl-item="${id}"]`)).filter(Boolean);
    page.querySelector('[data-wl-empty]').hidden = items.length > 0;
    grid.hidden = items.length === 0;
    grid.querySelectorAll('[data-wl-item]').forEach((el) => { el.hidden = true; });
    items.forEach((el) => { el.hidden = false; grid.appendChild(el); });
  }

  function renderAll() {
    const ids = read();
    renderBadge(ids);
    document.querySelectorAll('[data-mizu-wish-toggle]').forEach((b) => renderButton(b, ids));
    renderPage(ids);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-mizu-wish-toggle]');
    if (!btn) return;
    e.preventDefault(); // the card heart sits inside the product link
    const id = btn.dataset.mizuWishToggle;
    const ids = read();
    write(ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]);
    renderAll();
  });
  addEventListener('storage', (e) => { if (e.key === KEY) renderAll(); });
  document.addEventListener('mizu:swap', renderAll);
  renderAll();
})();
